import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import {createApi} from "@reduxjs/toolkit/query/react";

export const categoriesApi = createApi({
    reducerPath: 'categoriesApi',
    tagTypes: ['categories'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getCategories: build.query({
            query: (data) => ({
                url: api.categories.getCategories(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, ...(queryArgs?.filter_ids ?? [])];
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(
                    ...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id))
                );
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return currentArg !== previousArg;
            },
            providesTags: ['categories']
        }),
        createCategory: build.mutation({
            query: (data) => ({
                url: api.categories.createCategory(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(newCategory, {dispatch, queryFulfilled}) {
                try {
                    const {data} = await queryFulfilled;
                    const changedData = {
                        ...data, ...newCategory
                    }
                    dispatch(
                        categoriesApi.util.updateQueryData('getCategories', {}, (draft) => {
                            draft.unshift(changedData);
                        })
                    );
                } catch (error) {
                    console.error('Failed to update cache after creating category:', error);
                }
            }
        }),
        editCategory: build.mutation({
            query: ({id, ...data}) => ({
                url: api.categories.editCategory(id),
                method: 'PUT',
                body: data
            }),
            async onQueryStarted(updatedCategory, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled;
                    dispatch(
                        categoriesApi.util.updateQueryData('getCategories', {}, (draft) => {
                            const index = draft?.findIndex(item => item.id === updatedCategory.id);
                            if (index !== -1) {
                                draft[index] = {...draft[index], ...updatedCategory};
                            }
                        })
                    );
                } catch (error) {
                    console.error('Failed to update cache after editing category:', error);
                }
            }
        }),

        deleteCategory: build.mutation({
            query: ({id}) => ({
                url: api.categories.deleteCategory(id),
                method: 'DELETE',
            }),
            async onQueryStarted(deletedCategory, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled;
                    dispatch(
                        categoriesApi.util.updateQueryData('getCategories', {}, (draft) => {
                            const index = draft.findIndex(item => item.id === deletedCategory.id);
                            if (index !== -1) {
                                draft.splice(index, 1);
                            }
                        })
                    );
                } catch (error) {
                    console.error('Failed to update cache after deleting category:', error);
                }
            }
        }),
    })
});
export const {useLazyGetCategoriesQuery, useDeleteCategoryMutation} = categoriesApi